import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface SystemAdmin {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
}

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  admin: SystemAdmin | null;
  socketRooms: string[];
  initialized: boolean;
}

const initialState: AuthState = {
  accessToken: null,
  refreshToken: null,
  admin: null,
  socketRooms: [],
  initialized: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        admin: SystemAdmin;
      }>,
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.admin = action.payload.admin;
    },
    setTokens(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>,
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setInit(
      state,
      action: PayloadAction<{ admin: SystemAdmin; socketRooms: string[] }>,
    ) {
      state.admin = action.payload.admin;
      state.socketRooms = action.payload.socketRooms;
      state.initialized = true;
    },
    logout(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.admin = null;
      state.socketRooms = [];
      state.initialized = false;
    },
  },
});

export const { setCredentials, setTokens, setInit, logout } = authSlice.actions;
export default authSlice.reducer;
